var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.tableDesignModelVisible,
      title: _vm.$t("表格设计区"),
      width: 1200,
      height: 400,
      footer: null
    },
    on: {
      cancel: function ($event) {
        return _vm.$emit("update:tableDesignModelVisible", false);
      }
    }
  }, [_vm.tableDesignModelVisible ? _c("table-design-component", {
    on: {
      saveData: _vm.saveData
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };